import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { LlmTestausOp, LlmTestausPyynto, LlmTestausPyyntoMap } from '../../_jaettu-lemonator/model/llm-kirjausehdotus-testaus'

export function callLlmTestaus<K extends LlmTestausOp>(firebase: FirebaseLemonator, op: K, payload: LlmTestausPyyntoMap[K]['req']): Promise<LlmTestausPyyntoMap[K]['resp']> {
  return firebase.functionsCall<LlmTestausPyynto, LlmTestausPyyntoMap[K]['resp']>('llmTestaus', { op, payload } as LlmTestausPyynto)
}
